<script setup>
import LeftsideBarVue from "@/components/LeftsideBar.vue";
import MainComponent from "@/components/MainComponent.vue";
import RightsideBar from "@/components/RightsideBar.vue";
import ArtistSection from "@/components/ArtistSection.vue";
import WarningBox from "@/components/WarningBox.vue";


import { onMounted, ref } from "vue";
import axios from "axios";

const totalViews = ref(0);

const incrementView = async () => {
  try {
    const response = await axios.post("/api/views/increment");
    totalViews.value = response.data.total_views;
  } catch (error) {
    console.error("Failed to increment views:", error);
  }
};

onMounted(() => {
  incrementView();
});

</script>

<template>
  <!-- Warning Box -->
  <WarningBox />

  <!-- Move totalViews here to ensure uniform column top alignment -->
  <div v-if="totalViews > 0" v-reveal="{ y: 16 }" class="mt-6 mb-1 flex justify-center relative z-20">
    <div class="bg-white px-5 py-1.5 rounded-md shadow-sm border border-gray-200/70 flex items-center gap-2.5">
      <i class="fa-regular fa-eye text-gray-400 text-sm"></i>
      <span class="text-gray-500 text-sm font-medium">Total Views</span>
      <span class="h-4 w-px bg-gray-200"></span>
      <span class="text-brand-red-dark font-bold text-base tabular-nums">{{ totalViews.toLocaleString('en-IN') }}</span>
    </div>
  </div>

  <!-- Outer wrapper -->
  <div class="relative max-w-[1440px] 2xl:max-w-[1700px] w-full mx-auto overflow-x-hidden flex flex-col md:grid md:grid-cols-12 gap-6 py-6 md:py-8 px-4 xl:px-8">

  <div class="order-2 md:order-1 md:col-span-3 relative z-10 h-full">
    <LeftsideBarVue />
  </div>

  <!-- Right Hand Virtual Wrapper (Main + RightSidebar + Artist) -->
  <div class="contents md:flex md:flex-col md:col-span-9 md:order-2 md:gap-6 relative z-10 h-full justify-between">
    
    <!-- Top Row Virtual Wrapper -->
    <div class="contents md:grid md:grid-cols-9 md:gap-6 md:items-stretch">
      <div class="order-1 md:order-1 md:col-span-6 relative z-10 h-full">
        <MainComponent />
      </div>

      <div class="order-3 md:order-2 md:col-span-3 relative z-10 h-full">
        <RightsideBar />
      </div>
    </div>

    <!-- Artist Section natively flows upward directly beneath Top Row -->
    <div class="order-4 md:order-3 w-full relative z-10 mt-auto">
      <ArtistSection />
    </div>

  </div>

</div>

</template>

<style scoped>
/* Optional: tweak container background if needed */
</style>
